<template>
  <!-- 중간검사/사후 검사 -->
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      :retain-focus="false"
      content-class="bottom-sheet min-height-auto"
  >
    <v-card>
      <v-card-title>
        {{ datas[flag].title }}
        <v-btn icon @click="$emit('sheetClose')">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-img :src="getImage('ic_examine.svg')" class="mx-auto my-5" width="100px"></v-img>
      </v-card-text>
      <v-card-actions>
        <BlackBtn block x-large :str="datas[flag].btn" @click="$emit('examination',flag)"></BlackBtn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close'
import BlackBtn from "@/components/btns/BlackBtn";

export default {
  props: {
    sheet: Boolean,
    flag: Number,
  },
  data: () => ({
    datas: [
      {title: '중간검사를 진행해주세요!', btn: '중간 검사 하러가기'},
      {title: '사후검사를 진행해주세요!', btn: '사후 검사 하러가기'}
    ]
  }),
  components: {
    Close,
    BlackBtn
  },
  methods: {}
}
</script>
